<template>
  <div class="twitch" :class="{ss: showStreamerSquare}">
    <div class="twitch-description">
      <div class="btn-wrap">
        <button v-on:click="changeStream('lowco')" class="link-btn title" :class="{selected: !showStreamerSquare}" aria-label="switch to streaming lowco" title="switch to streaming lowco"><h2>My&nbsp;Twitch</h2></button>
        <span class="spacers" style="flex: 1;">&nbsp;</span> 
        <button v-on:click="changeStream('StreamerSquare')" class="link-btn title ss" :class="{selected: showStreamerSquare}" aria-label="switch to streaming StreamerSquare" title="switch to streaming StreamerSquare"><h2>StreamerSquare</h2></button>
        <span class="spacers" style="flex: 2;"></span> 
      </div>
      <div v-show="showStreamerSquare">
        <p>StreamerSquare is a website and stream dedicated to helping others in the streaming industry</p>
        <p>StreamerSquare is <stream-status :channelId="'61099751'" :channelName="'streamer-square'"></stream-status></p>
        <p class="website">Website: <a class="link-btn title ss" href="https://streamersquare.com/" title="StreamerSquare.com">StreamerSquare.com</a></p>
      </div>
      <div v-show="!showStreamerSquare">
        <p>I mostly play popular/new games for PC, PS4, and XB1.</p>
        <p class="no-margin-top">My schedule: <stream-times></stream-times></p>
        <p>Lowco is <stream-status :channelId="'52925091'" :channelName="'lowco'"></stream-status></p>
      </div>
    </div>
    <div class='twitch-stream' :class="{ss: showStreamerSquare}">
      <iframe :src="'https://player.twitch.tv/?channel=' + stream + '&parent=' + domainName + '&muted=true'" frameborder="0" scrolling="no" title="Lowco's embedded twitch stream"></iframe>
    </div>
  </div>
</template>

<script>
import StreamStatus from '../global/StreamStatus'
import StreamTimes from '../global/StreamTimes'

export default {
  name: 'twitch',
  components: {StreamStatus, StreamTimes},
  data () {
    return {
      stream: 'lowco',
      streamDesc: 'I mostly play popular/new games for PC, PS4, and XB1.'
    }
  },
  computed: {
    showStreamerSquare: function () {
      return this.stream === 'StreamerSquare'
    },
    domainName: function () {
      return window.location.hostname
    }
  },
  methods: {
    changeStream: function (target) {
      this.stream = target
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../variables.scss';
.twitch{
  display: flex;
  flex-flow: row-reverse;
  justify-content: center;
  padding: $home-section-padding;
  background-color: $dark-purple;
  color: $font-white;
  text-align: left;
  transition: background 500ms linear;
  &.ss  {
    background-color: #024677;
  }
}

.twitch-description {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  margin-left: $standard-spacing;
  max-width: 31.15em;
  .btn-wrap{
    display: flex;
    justify-content: space-between;
  }
  .no-margin-top{
    margin-top: 0;
  }
  .website {
    margin-top: 1.75em;
  }
  .title{
    margin: 0;
    &.ss {
      text-transform: uppercase;
      border-color: #1498e0;
      &:hover,
      &:focus,
      &.selected {
        background-color: #1498e0;
      }
    }
    &.selected {
      background-color: $light-purple;
    }
    h2 {
      margin: 0;
    }
  }
}

.twitch-stream {
  position: relative;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  min-width: 360px;
  max-width: 720px;
  box-shadow: 0 0 0 2px $light-purple;
  flex-basis: auto;
  flex-grow: 1;
  margin-right: $standard-spacing;
  transition: box-shadow 500ms linear;
  &.ss {
    box-shadow: 0 0 0 2px #1498e0;
  }
}

.twitch-stream:before{
  content: "";
  display: block;
  padding-top: 56.25%; /* 16:9 */
}

.twitch-stream iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

@media (max-width: 800px) {
  .twitch{
    flex-flow: row wrap;
  }
  .twitch-stream{
    margin: $standard-spacing 0 0 0;
  }
  .twitch-description {
    text-align: center;
    .btn-wrap {
      justify-content: space-around;
    }
  }
  .spacers {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Twitch.vue?759fbd54